import React from 'react';
import AdmissionEnNonValeurComponent
  from '../../../../components/Mouvement/Panel/InformationsRattachement/AdmissionEnNonValeurComponent';
import InformationsRattachementPanel from '../InformationsRattachementPanel';

class AdmissionEnNonValeurPanel extends InformationsRattachementPanel {
  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <AdmissionEnNonValeurComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default AdmissionEnNonValeurPanel;
